export default {
  title: 'Ariadne',
  subtitle: 'Explorer',
  bottomLine: 'Auf den Bildschirm tippen, um den Prototypen zu starten',
}
